<template>

  <div v-if="currentScheme" class="vehicle-search-component">
    <div>
      <vehicle-search-hero-component :currentProduct="currentProduct" :scheme="currentScheme"/>
      <vehicle-search-contract-parameters-component
        v-if="adminPortalData && defaultSort"
        :adminPortalData="adminPortalData"
        :defaultSort="defaultSort"
        :currentProduct="currentProduct"
        :scheme="currentScheme"
        :formData="formData"
        :manufacturers="manufacturers"
        :filters="filters"
        :fourWheelDriveOptions="fourWheelDriveOptions"
        :ranges="ranges"
        :models="models"
        :rangesRequireRefresh="rangesRequireRefresh"
        :modelsRequireRefresh="modelsRequireRefresh"
        :showShortlistedCars="showShortlistedCars"
        :canShowMonthlyRentalFilter="canShowMonthlyRentalFilter"
        :driverGrades="availableDriverGrades"
        @showShortlistedCars="showShortlistedCars = $event"
      />
      <vehicle-search-results-component
        v-if="shortlist && session"
        :adminPortalData="adminPortalData"
        :currentProduct="currentProduct"
        :scheme="currentScheme"
        :formData="formData"
        :shortlist="shortlist"
        :vehicles="vehicles"
        :loadMoreBtnVisible="loadMoreBtnVisible"
        :session="session"
        :total-records="totalRecords"
        :start-record="startRecord"
        :end-record="endRecord"
        :per-page="perPage"
        :showShortlistedCars="showShortlistedCars"
        :loading="loading"
        :driverGrades="availableDriverGrades"
        :currentDriverGrade="currentDriverGrade"
        :driverGradesById="driverGradesById"
        @paginationUpdated="loadMore"
      />
    </div>

    <footer-text v-if="footerText" :footerText="footerText" />
  </div>

</template>

<script>
import { EventBus } from '../event-bus.js';
import FooterText from "./footer/footer-text";
import VehicleSearchHeroComponent from "./vehicle-search-hero-component.vue";
import VehicleSearchResultsComponent from "./vehicle-search-results-component.vue";
import RatebookHelper from "@/helpers/ratebook";
import { useRoute } from "vue-router";

let formDefaultsObject = {
  method: 'GET',
  endpoint: 'vehiclesearch/derivatives',
  uri_params: {
    IncludeQuote: 'True',
    IncludeShortlists: 'True',
    OrderBy: 'RENTAL ASC',
    Skip: 0,
    Top: 16,
  },
  body_params: {
    AnnualDistance: null,
    AssetTypeID: null,
    BIKPercentage: null,
    BodyStyle: [],
    DriverGradeID: null,
    FourWheelDrive: null,
    FuelType: [],
    ManufacturerID: [],
    MaxBIK: 1500,
    MaxP11DValue: 125000,
    MinBIK: 0,
    //MinimumElectricRange: [],
    MinNoOfSeats: 0,
    MinP11DValue: 0,
    ModelID: [],
    ProductID: null,
    RangeID: [],
    Term: 48,
    TextSearch: null,
    TransmissionType: null,
  }
};

function formDefaults() {
  return formDefaultsObject;
}

export default {
  components: { FooterText, VehicleSearchHeroComponent, VehicleSearchResultsComponent },
  props: [
    'session',
    'adminPortalData'
  ],

  data: () => {
    return {
      vehicles: [],
      manufacturers: null,
      ranges: [],
      rangesRequireRefresh: false,
      models: [],
      modelsRequireRefresh: false,
      formData: formDefaults(),
      filters: null,
      fourWheelDriveOptions: [
        {value: null, description: 'Any'},
        {value: 'True', description: '4WD only'},
        {value: 'False', description: 'Not 4WD'}
      ],
      shortlist: null,
      error: null,
      loadMoreBtnVisible: false,
      totalRecords: 0,
      startRecord: 0,
      endRecord: 0,
      perPage: 0,
      showShortlistedCars: false,
      loading: false,
      availableDriverGrades: [],
      driverGradesById: {},
    }
  },

  setup() {
    const route = useRoute();
    return { route }
  },

  computed: {
    RatebookHelper()  {
      return RatebookHelper;
    },
    defaultSort() {
      if (this.currentScheme && this.adminPortalData?.content?.products?.[this.currentScheme]?.[0]?.your_shortlist_default_sort) {
        return this.adminPortalData.content.products[this.currentScheme][0].your_shortlist_default_sort + ' ' + this.adminPortalData.content.products[this.currentScheme][0].your_shortlist_default_sort_order;
      }
      return null;
    },
    canShowMonthlyRentalFilter() {
      if (this.currentScheme === 'salsac') {
        return false;

      } else if (this.currentScheme === 'bch') {
        // This should be amended to account for monthly rental when enabled for BCH
        return false;
      }

      return true;
    },
    footerText() {
      return this.currentScheme === 'ecoamaps'
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_description_required_on_your_shortlist
        ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
        : false;
    },
    currentProduct() {
      let currentProduct = {};

      if (this.adminPortalData?.content?.products?.[this.currentScheme]?.[0]) {
        currentProduct = this.adminPortalData.content.products[this.currentScheme][0];
      }

      return currentProduct;
    },
    currentScheme() {
      return this.route.params.scheme;
    },
    currentDriverGrade() {
      return this.session?.driverProfile?.driverGrades?.[this.currentScheme]?.grades?.[this.formData.body_params.DriverGradeID];
    }
  },

  watch: {
    // do stuff when session data is available
    session: function() {
      this.setSessionFormData();
      this.getVehicles();
    },

    showShortlistedCars: function(shortlistOnly) {
      if (shortlistOnly) {
        console.debug('getVehicles [shortlist only]')
      } else {
        console.debug('getVehicles [all]')
      }
    },

    adminPortalData: function() {
      /*if (this.adminPortalData.schemeId !== this.productType) {
        this.$router.push({ name: 'Shortlist', params: { productType: this.adminPortalData.schemeId.replace(/_/g, '-') }})
      }*/
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.vehicles = [];
      EventBus.$emit('fetchData', [
        'shortlists',
        'driverprofile',
        'drivergrades',
      ]);
      vm.resetFormData();
    })
  },

  beforeRouteLeave (to, from, next) {
    if (!this.shortlist || this.shortlist.quotes.length <= 0 && ['Car Comparison', 'Configure Vehicle'].includes(to.name)){
      EventBus.$emit('showError', true);
      EventBus.$emit('errorTitle', 'Please make a selection');
      EventBus.$emit('errorMessage', 'You need at least one car on your shortlist to continue');
      return false;
    }
    next();
  },

  mounted() {
    EventBus.$on('addToShortlist', (derivative) => {
      if (this.shortlist.quotes == null) {
        this.shortlist.quotes = [];
      }
      this.shortlist.quotes.push(derivative);
    });
    EventBus.$on('removeFromShortlist', (derivativeID) => {
      this.shortlist.quotes = this.shortlist.quotes.filter((derivative) => {
        return derivative.derivativeID !== derivativeID;
      });
    });
  },

  methods: {
    // apply data from session to default form data
    setSessionFormData() {
      //body_params.DriverGradeID
      const driverGradeId = Object.keys(this.session.driverProfile.driverGrades[this.currentScheme].grades)[0];
      const driverGrade = this.session.driverProfile.driverGrades[this.currentScheme].grades[driverGradeId];
      const driverGradeArray = Object.keys(this.session.driverProfile.driverGrades[this.currentScheme].grades).map((key) => this.session.driverProfile.driverGrades[this.currentScheme].grades[key]);
      // Pass this back so we only do ratebook lookups on BCH customers
      this.formData.scheme = this.route.params.scheme;

      this.formData.body_params.AssetTypeID = driverGrade.assetTypes[0].assetTypeID;
      this.formData.body_params.BIKPercentage = this.session.driverProfile.incomeTaxBand ? this.session.driverProfile.incomeTaxBand.ratePercent : 30;
      this.formData.body_params.DriverGradeID = driverGrade.driverGradeID;
      this.formData.body_params.ProductID = driverGrade.products[0].productID;
      this.manufacturers = driverGrade.manufacturers;
      this.shortlist = this.session.shortlists[this.currentScheme];
      this.formData.body_params.AnnualDistance = this.currentScheme === 'salsac' ? this.currentProduct.contract_parameters_mileage_default : this.session.driverProfile.annualCombinedDistanceInclAdjustment;
      this.formData.body_params.Term = driverGrade?.driverGradeDefinition?.term || this.currentProduct.contract_parameters_term_default;
      this.formData.body_params.FilterOnDeloitteCalculations = this.RatebookHelper.isRatebookEnabledGrade(driverGrade.driverGradeDefinition.name);

      this.driverGradesById = this.session.driverProfile.driverGrades[this.currentScheme].grades;
      this.availableDriverGrades = driverGradeArray ? driverGradeArray.map((grade) => {
        return {id: grade.driverGradeID, value: grade.driverGradeDefinition.friendlyName}
      }) : []
    },

    // get vehicle items for page
    getVehicles() {
      EventBus.$emit('loadingTitle', 'Retrieving Vehicles');
      EventBus.$emit('loading', true);
      this.loading = true;

      if (!this.formData?.body_params?.AssetTypeID) {
        return;
      }

      this.$http.post('/api/quotation', this.formData)
        .then(response => {
          EventBus.$emit('loading', false);
          this.loading = false;
          if (response.data.status === 200) {
            // wtf increase by 8 every search?!
            //this.formData.uri_params.Skip += 8;
            this.setVehicles(response.data.data.results);
            if (this.rangesRequireRefresh) {
              this.setRanges(response.data.data.filterRanges.ranges);
              this.rangesRequireRefresh = false;
            }
            if (this.modelsRequireRefresh) {
              this.setModels(response.data.data.filterRanges.models);
              this.modelsRequireRefresh = false;
            }

            this.totalRecords = response.data.data.totalRecords;
            this.startRecord = response.data.data.startRecord;
            this.endRecord = response.data.data.endRecord;
            this.perPage = this.formData.uri_params.Top;

            // 697604152 / 705662055 - call to dedicated filters endpoint returned repeat and irrelevant options
            // Switching to extracting the filter options from the search results fixes this
            // Previously pulled from `vehiclesearch/filters/all`
            this.filters = response.data.data.filterRanges;

            this.loadMoreBtnVisible = false;
          } else {
            for (let property in response.data.errors) {
              if (response.data.errors.hasOwnProperty(property)) {
                response.data.errors[property].forEach((error) => {
                  this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Error',
                    text: error
                  })
                });
              }
            }
          }
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          this.loading = false;
          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: err.toString()
          })
          this.error = err.toString()
        });
    },

    setVehicles(vehicles) {
      this.vehicles = vehicles;
    },

    setRanges(ranges) {
      this.ranges = ranges;
    },

    setModels(models) {
      this.models = models;
    },

    updateSearchResults() {
      this.updateFiltersFromDriverGradeValues();
      this.formData.uri_params.Skip = 0;
      this.vehicles = [];
      this.getVehicles();
    },

    updateFiltersFromDriverGradeValues() {
      if (this.currentScheme && this.session?.driverProfile?.driverGrades?.[this.currentScheme]?.grades?.[this.formData.body_params.DriverGradeID]?.driverGradeDefinition) {
        const driverGrade = this.session.driverProfile.driverGrades[this.currentScheme].grades[this.formData.body_params.DriverGradeID].driverGradeDefinition;
        if (driverGrade?.term) {
          this.formData.body_params.Term = driverGrade.term;
        }
        if (driverGrade?.distance) {
          this.formData.body_params.AnnualDistance = driverGrade.distance;
        }
      }
    },

    loadMore(e) {
      this.formData.uri_params.Skip = e.start;
      this.formData.uri_params.Top = this.perPage;
      this.getVehicles();
    },

    resetFormData(callback) {
      Object.assign(this.$data.formData, formDefaults());
      this.$data.ranges = [];
      this.$data.models = [];

      if (callback !== undefined) {
        callback();
      }
    }
  }
}
</script>
